import { useRef, useEffect } from 'react'

//replacement hook of componentWillRecieveProps
export const usePrevious = (value) => {
    const ref = useRef()

    useEffect(() => {
      ref.current = value
    }, [value])

    return ref.current
}